module.exports = __webpack_public_path__ + "static/pizza-476a2b19fb5d753574edf54d3143666d.jpg";